module.exports = __webpack_public_path__ + "img/logo.0c9f298d.svg";